import { nameof } from 'ts-simple-nameof'
import * as yup from 'yup'
import type { BaseAddressDto } from '../dtos/Person'

export const AddressValidationSchema = {
    postCode: yup
        .string()
        .nullable()
        .required('PSČ je povinné')
        .length(5, 'PSČ musí mít 5 číslic')
        .matches(/^[0-9]+$/, 'PSČ může obsahovat pouze číslice'),

    city: yup
        .string()
        .nullable()
        .required('Vyberte obec')
}

export const Step4AddressValidationSchema = {
    postCode: yup
        .string()
        .nullable()
        .required('PSČ je povinné')
        .length(5, 'PSČ musí mít 5 číslic')
        .matches(/^[0-9]+$/, 'PSČ může obsahovat pouze číslice'),

    city: yup
        .string()
        .nullable()
        .required('Vyberte obec'),

    street: yup
        .string()
        .nullable()
        .transform((value) => (value === '' ? null : value))
        .when(nameof<BaseAddressDto>(x => x.addressPoint), {
            is: (addressPoint?: number) => !addressPoint, // ulice je vyžadována, pokud není určeno adresní místo
            then: () => yup.string().nullable().required('Ulice je povinná'),
            otherwise: () => yup.string().optional()
        }),

    streetNumber: yup
        .string()
        .nullable()
        .required('Číslo popisné nebo orientační je povinné')
}